export default __webpack_public_path__ + "static/assets/med_pill_square_out_L0_solid_l_01_f.bce0cd67.png";